import React from 'react';
import { connect } from 'react-redux';

export default (ChildComponent) => {
    const WithAuth = (props) => {
        return (<ChildComponent {...props} />);
    };

    WithAuth.displayName = `WithAuth(${ChildComponent.displayName || ChildComponent.name || 'Component'})`;

    function mapStateToProps({ auth }) {
        return { auth };
    }

    return connect(mapStateToProps)(WithAuth);
};
